import { all } from 'redux-saga/effects'

import { dataSaga } from './data/saga'
import { submitSaga } from './submit/saga'

export function* editSaga() {
  yield all([dataSaga(), submitSaga()])
}
